import styled from 'styled-components';

export const ChangePaymentSelectMethodCheckRowStyled = styled.div`
    display: flex;
    align-items: center;
    padding: 16px;
    justify-content: space-between;
    border-radius: 12px;
    cursor: pointer;
    
    &:hover {
        background: var(--color-neutral-10);
    }
`;

export const ChangePaymentSelectMethodButtonsStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ChangePaymentSelectMethodInfoStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 16px
`;
